<template>



<section class="kc-elm kc-css-468985 kc_row">
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr5" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr6" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr7" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr8" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="kc-row-container  kc-container">
      <div class="kc-wrap-columns">
         <div class="kc-elm kc-css-41368 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
               <div class="kc-elm kc-css-173781 kc_row kc_row_inner sst-flex-row-inner">
                  <div class="kc-elm kc-css-50523 kc_col-sm-7 kc_column_inner kc_col-sm-7">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_mltttl  kc-elm kc-css-580429 ">
                           <h2 class="wr deb derb dea dera none nonea"><span class="t1">The</span><span class="t2"> services</span><span class="t3"> we offer</span></h2>
                        </div>
                        <div class="ssc_mltttl  kc-elm kc-css-140260 ">
                           <h3 class="wr deb derb dea dera none nonea"><span class="t1">We offer professional web design services at affordable rates to help your business attract more visitors and keep them on your site!</span></h3>
                        </div>
                        <div class="bgrlabel  kc-elm kc-css-363385" style="bottom:10px;right:-840px;">
                           <div class="inside_wrap">
                              <div class="imgl"><img class=" lazyloaded" data-src="../../assets/images/Canvas.png" alt="" src="../../assets/images/Canvas.png"></div>
                           </div>
                        </div>
                        <div class="kc-elm kc-css-103659 kc_row kc_row_inner sst-flex-row-inner">
                           <div class="kc-elm kc-css-507621 kc_col-sm-6 kc_column_inner kc_col-sm-6">
                              <div class="kc_wrapper kc-col-inner-container">
                                 <div class="ssc_icon_box kc-elm kc-css-303380 template3 ">
                                    <div class="icon_box">
                                       <div class="bgr_no" style="width:90px; height:90px;">
                                          <div> </div>
                                       </div>
                                       <div class="c_img" style="margin-top: -90px; line-height:90px; height:90px; width:90px;"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/wifi-1.png" alt="Web Development" style="max-width: 70px; max-height: 70px;margin-top: calc((90px - 70px)/2);" src="../../assets/images/wifi-1.png"></div>
                                    </div>
                                    <div class="cont_box">
                                       <div class="title">Web Development</div>
                                       <div class="description lines0">
                                          <p>We start from structuring information architecture and mapping out functionalities.</p>
                                       </div>
                                       <a href="/" class="rm pos">Learn more</a>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="kc-elm kc-css-89153 kc_col-sm-6 kc_column_inner kc_col-sm-6">
                              <div class="kc_wrapper kc-col-inner-container">
                                 <div class="ssc_icon_box kc-elm kc-css-175500 template3 ">
                                    <div class="icon_box">
                                       <div class="bgr_no" style="width:90px; height:90px;">
                                          <div> </div>
                                       </div>
                                       <div class="c_img" style="margin-top: -90px; line-height:90px; height:90px; width:90px;"><img class=" lazyloaded" data-src="../../assets/images/commerce.png" alt="E - commerce" style="max-width: 70px; max-height: 70px;margin-top: calc((90px - 70px)/2);" src="../../assets/images/commerce.png"></div>
                                    </div>
                                    <div class="cont_box">
                                       <div class="title">E - commerce</div>
                                       <div class="description lines0">
                                          <p>We build digital shopping experiences to meet ambitious sales goals for your e-commerce business.</p>
                                       </div>
                                       <a href="/" class="rm pos">Learn more</a>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="kc-elm kc-css-809180 kc_row kc_row_inner sst-flex-row-inner">
                           <div class="kc-elm kc-css-455932 kc_col-sm-6 kc_column_inner kc_col-sm-6">
                              <div class="kc_wrapper kc-col-inner-container">
                                 <div class="ssc_icon_box kc-elm kc-css-582621 template3 ">
                                    <div class="icon_box">
                                       <div class="bgr_no" style="width:90px; height:90px;">
                                          <div> </div>
                                       </div>
                                       <div class="c_img" style="margin-top: -90px; line-height:90px; height:90px; width:90px;"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/app-dev.png" alt="App Development" style="max-width: 70px; max-height: 70px;margin-top: calc((90px - 70px)/2);" src="../../assets/images/app-dev.png"></div>
                                    </div>
                                    <div class="cont_box">
                                       <div class="title">App Development</div>
                                       <div class="description lines0">
                                          <p>Our professional app developers build custom mobile apps to assist in the growth of your business.</p>
                                       </div>
                                       <a href="/" class="rm pos">Learn more</a>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="kc-elm kc-css-550621 kc_col-sm-6 kc_column_inner kc_col-sm-6">
                              <div class="kc_wrapper kc-col-inner-container">
                                 <div class="ssc_icon_box kc-elm kc-css-441957 template3 ">
                                    <div class="icon_box">
                                       <div class="bgr_no" style="width:90px; height:90px;">
                                          <div> </div>
                                       </div>
                                       <div class="c_img" style="margin-top: -90px; line-height:90px; height:90px; width:90px;"><img class=" lazyloaded" data-src="../../assets/images/seo.png" alt="SEO optimization" style="max-width: 70px; max-height: 70px;margin-top: calc((90px - 70px)/2);" src="../../assets/images/seo.png"></div>
                                    </div>
                                    <div class="cont_box">
                                       <div class="title">SEO optimization</div>
                                       <div class="description lines0">
                                          <p>Culmination of website content and off-site presence to improve rankings in the major search engines.</p>
                                       </div>
                                       <a href="/" class="rm pos">Learn more</a>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-506813 kc_col-sm-5 kc_column_inner kc_col-sm-5">
                     <div class="kc_wrapper kc-col-inner-container"></div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>



</template>

<script>
export default {
  name: "Offer",
  props: ["title", "subtitle", "header"],
  data() {
    return {
      msg: "Offer"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all{
*,.kc-col-container,.kc-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
.kc_col-sm-5{width:41.6667%;}
.kc_col-sm-6{width:50%;}
.kc_col-sm-7{width:58.3333%;}
.kc_col-sm-12{width:100%;}
.kc-container{width:100%;max-width:1170px;margin:0 auto;padding-left:15px;padding-right:15px;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{margin-left:-15px;margin-right:-15px;clear:both;}
.kc_row.kc_row_inner{width:calc(100% + 30px);}
.kc_column,.kc_column_inner{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container,.kc_column_inner>.kc-col-inner-container{height:100%;}
.kingcomposer div.kc_column,.kingcomposer div.kc_column_inner{clear:none;}
.kc-col-container{clear:both;display:block;width:100%;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns,.kc_row_inner{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{width:calc(100% + 30px);}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column,body.kc-css-system .kc_column_inner{width:100%;}
div.kc_row{display:block;}
}
.entry-content a{box-shadow:none;}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus{outline:none;}
section{display:block;}
img{border:0;max-width:100%;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:40px;line-height:52px;text-transform:full-size-kana;text-align:left;margin:20px 0 15px 0;}
h3{font-family:"Catamaran";color:#222;font-weight:500;font-size:25px;line-height:32px;text-align:left;margin:20px 0;}
p{margin:10px 0 25px 0;}
.page p{line-height:29px;}
*,*:before,*:after{box-sizing:inherit;}
.kc_row.kc_row_inner:focus{outline:none;}
img{height:auto;max-width:100%;}
.kc-row-container:after{content:"";display:block;clear:both;}
.kc-col-container>div{position:relative;}
@media screen and (max-width:601px){
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;}
p{margin:10px 0 25px 0;line-height:26px;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;margin:20px 0;}
}
body .bgrlabel{float:none;position:absolute;display:inline-block;width:auto;}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.ssc_icon_box.kc-elm{margin-bottom:10px;width:auto;}
.ssc_icon_box:after{content:"";display:block;clear:both;}
.ssc_icon_box a{transition:all 300ms ease-in;}
.ssc_icon_box,.ssc_icon_box .bgr_no,.ssc_icon_box .c_img,.ssc_icon_box .c_img img,.ssc_icon_box .icon_box,.ssc_icon_box .cont_box,.ssc_icon_box .title,.ssc_icon_box .cont_box .description,.ssc_icon_box .cont_box .rm{transition:all 350ms ease-in;}
.ssc_icon_box.template3{text-align:center;}
.ssc_icon_box.template3 .title{margin-top:20px;}
.ssc_icon_box.template3 .bgr_no{margin:0 auto;}
.ssc_icon_box.template3 .icon_box{width:100%;}
.ssc_icon_box .bgr_no{position:relative;z-index:1;display:block;}
.ssc_icon_box .bgr_no div{display:block;}
.ssc_icon_box .c_img{position:relative;z-index:9;text-align:center;margin-left:auto;margin-right:auto;}
.ssc_icon_box .c_img img{margin-top:calc((90px - 40px)/2);}
.ssc_icon_box .icon_box{width:10px;}
.ssc_icon_box .cont_box{vertical-align:top;}
.ssc_icon_box .title{margin-bottom:2px;font-size:20px;font-weight:700;}
.ssc_icon_box .cont_box .description{line-height:1.4em;}
.ssc_icon_box .cont_box .description p:first-child{margin-top:0;}
.ssc_icon_box .cont_box .description p:last-child{margin-bottom:0;}
.ssc_icon_box .cont_box .rm{display:inline-block;position:relative;font-size:13px;}
.main [class*="lines"]{display:-webkit-box!important;-webkit-box-orient:vertical;overflow:hidden;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
@media screen and (max-width:480px){
.ssc_icon_box .c_img,.ssc_icon_box .bgr_no{margin-left:auto;margin-right:auto;}
.ssc_icon_box .icon_box{text-align:center;}
}
.ssc_mltttl>h2,.ssc_mltttl>h3{display:inline-block;width:auto;position:relative;}
.deb:before,.dea:after{position:absolute;content:'';display:block;top:0;transition:all 400ms;}
.deb.none:before,.dea.nonea:after{content:none;}
.derb:before,.dera:after{right:0;}
.kc-col-container:after{content:"";display:block;clear:both;}
.sst-flex-row-inner{position:relative;z-index:1;min-height:30px;}
}
/*! CSS Used from: Embedded */
@media (max-width: 479px){
h2{font-size:30px;line-height:34px!important;}
}
/*! CSS Used from: Embedded */
.kc-container{max-width:1170px;}
/*! CSS Used from: Embedded */
@media only screen and (min-width:1000px) and (max-width:5000px){
body.kc-css-system .kc-css-41368{width:100%;}
body.kc-css-system .kc-css-50523{width:60%;}
body.kc-css-system .kc-css-507621{width:50%;}
body.kc-css-system .kc-css-89153{width:50%;}
body.kc-css-system .kc-css-455932{width:50%;}
body.kc-css-system .kc-css-550621{width:50%;}
body.kc-css-system .kc-css-506813{width:39.99%;}
}
body.kc-css-system .kc-css-468985{background:#b86f60 url(../../assets/images/Servicess-Outer-Stroke.jpg) center center/cover no-repeat scroll;margin-top:100px;padding-top:120px;padding-bottom:140px;}
body.kc-css-system .kc-css-580429{display:inline-block;}
body.kc-css-system .kc-css-580429 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;}
body.kc-css-system .kc-css-580429 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:17px;margin-right:-4px;}
body.kc-css-system .kc-css-580429 .t1{color:#ffffff;}
body.kc-css-system .kc-css-580429 .t2{color:#222222;}
body.kc-css-system .kc-css-580429 .t3{color:#ffffff;}
body.kc-css-system .kc-css-140260{display:inline-block;}
body.kc-css-system .kc-css-140260 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;}
body.kc-css-system .kc-css-140260 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:17px;margin-right:-4px;}
body.kc-css-system .kc-css-140260 .t1{color:#ffffff;}
body.kc-css-system .kc-css-363385{text-align:right;}
body.kc-css-system .kc-css-103659{padding-top:15px;}
body.kc-css-system .kc-css-507621{padding-right:30px;}
body.kc-css-system .kc-css-303380{text-align:left;padding-top:15px;}
body.kc-css-system .kc-css-303380 .c_img{text-align:left;margin-left:0px;padding-top:3px;}
body.kc-css-system .kc-css-303380 .bgr_no{text-align:left;}
body.kc-css-system .kc-css-303380 .bgr_no{margin-left:0px;}
body.kc-css-system .kc-css-303380 .bgr_no{padding-left:0px;}
body.kc-css-system .kc-css-303380 .title{color:#ffffff;font-size:20px;line-height:30px;font-weight:700;text-align:left;text-transform:none;}
body.kc-css-system .kc-css-303380 .cont_box .description{color:#ffffff;font-size:17px;font-weight:400;font-family:Catamaran;padding-top:5px;}
body.kc-css-system .kc-css-303380 .cont_box .description,body.kc-css-system .kc-css-303380 .cont_box .description p{line-height:30px;}
body.kc-css-system .kc-css-303380 .cont_box .rm{color:#ED7D31;font-size:16px;line-height:40px;font-weight:600;text-decoration:none;background:#ffffff;margin-top:30px;padding-right:28px;padding-left:28px;border-radius:30px 30px 30px 30px;}
body.kc-css-system .kc-css-303380 .cont_box{text-align:left;}
body.kc-css-system .kc-css-303380 .cont_box .rm:hover{color:#ffffff;background:#222222;}
body.kc-css-system .kc-css-89153{padding-left:50px;}
body.kc-css-system .kc-css-175500{text-align:left;padding-top:15px;}
body.kc-css-system .kc-css-175500 .c_img{text-align:left;margin-left:0px;padding-top:3px;}
body.kc-css-system .kc-css-175500 .bgr_no{text-align:left;}
body.kc-css-system .kc-css-175500 .bgr_no{margin-left:0px;}
body.kc-css-system .kc-css-175500 .bgr_no{padding-left:0px;}
body.kc-css-system .kc-css-175500 .title{color:#ffffff;font-size:20px;line-height:30px;font-weight:700;text-align:left;text-transform:none;}
body.kc-css-system .kc-css-175500 .cont_box .description{color:#ffffff;font-size:17px;font-weight:400;font-family:Catamaran;padding-top:5px;}
body.kc-css-system .kc-css-175500 .cont_box .description,body.kc-css-system .kc-css-175500 .cont_box .description p{line-height:30px;}
body.kc-css-system .kc-css-175500 .cont_box .rm{color:#ED7D31;font-size:16px;line-height:40px;font-weight:600;text-decoration:none;background:#ffffff;margin-top:30px;padding-right:28px;padding-left:28px;border-radius:30px 30px 30px 30px;}
body.kc-css-system .kc-css-175500 .cont_box{text-align:left;}
body.kc-css-system .kc-css-175500 .cont_box .rm:hover{color:#ffffff;background:#222222;}
body.kc-css-system .kc-css-809180{padding-top:70px;}
body.kc-css-system .kc-css-455932{padding-right:30px;}
body.kc-css-system .kc-css-582621{text-align:left;padding-top:15px;}
body.kc-css-system .kc-css-582621 .c_img{text-align:left;margin-left:0px;padding-top:3px;}
body.kc-css-system .kc-css-582621 .bgr_no{text-align:left;}
body.kc-css-system .kc-css-582621 .bgr_no{margin-left:0px;}
body.kc-css-system .kc-css-582621 .bgr_no{padding-left:0px;}
body.kc-css-system .kc-css-582621 .title{color:#ffffff;font-size:20px;line-height:30px;font-weight:700;text-align:left;text-transform:none;}
body.kc-css-system .kc-css-582621 .cont_box .description{color:#ffffff;font-size:17px;font-weight:400;font-family:Catamaran;padding-top:5px;}
body.kc-css-system .kc-css-582621 .cont_box .description,body.kc-css-system .kc-css-582621 .cont_box .description p{line-height:30px;}
body.kc-css-system .kc-css-582621 .cont_box .rm{color:#ED7D31;font-size:16px;line-height:40px;font-weight:600;text-decoration:none;background:#ffffff;margin-top:30px;padding-right:28px;padding-left:28px;border-radius:30px 30px 30px 30px;}
body.kc-css-system .kc-css-582621 .cont_box{text-align:left;}
body.kc-css-system .kc-css-582621 .cont_box .rm:hover{color:#ffffff;background:#222222;}
body.kc-css-system .kc-css-550621{padding-left:50px;}
body.kc-css-system .kc-css-441957{text-align:left;padding-top:15px;}
body.kc-css-system .kc-css-441957 .c_img{text-align:left;margin-left:0px;padding-top:3px;}
body.kc-css-system .kc-css-441957 .bgr_no{text-align:left;}
body.kc-css-system .kc-css-441957 .bgr_no{margin-left:0px;}
body.kc-css-system .kc-css-441957 .bgr_no{padding-left:0px;}
body.kc-css-system .kc-css-441957 .title{color:#ffffff;font-size:20px;line-height:30px;font-weight:700;text-align:left;text-transform:none;}
body.kc-css-system .kc-css-441957 .cont_box .description{color:#ffffff;font-size:17px;font-weight:400;font-family:Catamaran;padding-top:5px;}
body.kc-css-system .kc-css-441957 .cont_box .description,body.kc-css-system .kc-css-441957 .cont_box .description p{line-height:30px;}
body.kc-css-system .kc-css-441957 .cont_box .rm{color:#ED7D31;font-size:16px;line-height:40px;font-weight:600;text-decoration:none;background:#ffffff;margin-top:30px;padding-right:28px;padding-left:28px;border-radius:30px 30px 30px 30px;}
body.kc-css-system .kc-css-441957 .cont_box{text-align:left;}
body.kc-css-system .kc-css-441957 .cont_box .rm:hover{color:#ffffff;background:#222222;}
@media only screen and (max-width:1024px){
body.kc-css-system .kc-css-363385{display:none;}
body.kc-css-system .kc-css-89153{padding-left:15px;}
body.kc-css-system .kc-css-809180{padding-top:30px;}
body.kc-css-system .kc-css-550621{padding-left:15px;}
}
@media only screen and (max-width:999px){
body.kc-css-system .kc-css-468985{padding-top:60px;padding-bottom:60px;}
body.kc-css-system .kc-css-50523{margin-left:0%;width:100%;}
}

</style>



// WEBPACK FOOTER //
// src/components/Blocks/Offer.vue